module.exports = __webpack_public_path__ + "static/media/varejo-2.71530607.jpg";